<template>
  <div class="star-rating">
    <star
      v-for="answer in apiData.options"
      v-bind:key="answer.id"
      :starId="answer.id"
      :text="answer.text"
      :currentRating="currentRating"
      @answer-selected="setRating($event, true)"
    >    
    </star>
  </div>
</template>

<script>

  import Star from './Star.vue' 

	export default {
	  name: 'StarRating',
	  components: {
	    Star
	  },
    model: {
      prop: 'rating',
      event: 'rating-selected'
    },
	  props: {
      apiData: Object,
      starSelected: {
        type: Number,
        default: null
      }
	  },
    methods: {
      setRating($event) {
        this.currentRating = $event.id
        this.$emit('rating-selected', this.currentRating)
      }
    },
    watch: {
        rating(val) {
            this.currentRating = val
            this.selectedRating = val
        }
    },
    data: function () {
      return {
        selectedRating: null,
        currentRating: null
      }
    }
	}
</script>